import { ExtendedRoute } from "@/types/route";
import { BsGrid } from "react-icons/bs";
import { HiOutlineUserCircle, HiOutlineUserGroup } from "react-icons/hi2";
import { MdOutlineShield } from "react-icons/md";
import { PiBoundingBox, PiListMagnifyingGlass } from "react-icons/pi";

const USER_ROUTE_CONFIG = {
	title: 'Users',
	showTitleBar: false,
	icon: <HiOutlineUserCircle />
}

const GROUP_ROUTE_CONFIG = {
	title: 'Groups',
	showTitleBar: false,
	icon: <HiOutlineUserGroup />
}

const AUDIT_LOG_ROUTE_CONFIG = {
	title: "Audit Logs",
	showTitleBar: true,
	icon: <PiListMagnifyingGlass />,
}

const PROFILE_ROUTE: Partial<ExtendedRoute>[] = [
	{
		path: '/domain/profile',
		title: 'Profile',
		icon: <MdOutlineShield />,
		showTitleBar: false,
	},
];

const ADMIN_ROUTES: Partial<ExtendedRoute>[] = [
	{
		path: '/admin/applications',
		title: 'Applications',
		showTitleBar: true,
		icon: <PiBoundingBox />
	},
	{
		path: '/admin/organisations',
		title: 'Organisations',
		showTitleBar: true,
		icon: <BsGrid />,
	},
	{
		path: '/admin/users',
		...USER_ROUTE_CONFIG
	},
	{
		path: '/admin/groups',
		...GROUP_ROUTE_CONFIG,
	},
	{
		path: "/admin/audit-logs",
		...AUDIT_LOG_ROUTE_CONFIG
	}
];

const DOMAIN_ROUTES: Partial<ExtendedRoute>[] = [
	{
		path: '/domain/users',
		...USER_ROUTE_CONFIG,
	},
	{
		path: '/domain/groups',
		...GROUP_ROUTE_CONFIG
	},
	...PROFILE_ROUTE,
	{
		path: "/domain/audit-logs",
		...AUDIT_LOG_ROUTE_CONFIG
	}
];

export { ADMIN_ROUTES, AUDIT_LOG_ROUTE_CONFIG, DOMAIN_ROUTES, GROUP_ROUTE_CONFIG, PROFILE_ROUTE, USER_ROUTE_CONFIG };

